import { observer } from 'mobx-react-lite'
import { EmptyState, Table } from 'shared/ui'
import { useClickToTextDetailsContext } from 'pages/clickToText/pages/viewClickToText/context'
import { columns } from './columns'
import styles from './styles.module.scss'

export const ClickToTextStatisticsTableClicks = observer(() => {
  const {
    statisticsClicksItems,
    isNoClicksData,
    total,
    isStatisticsClicksLoading,
    onPaginationTableChange,
    page,
    limit,
    statisticsClicksTableStore,
  } = useClickToTextDetailsContext()

  if (isNoClicksData) {
    return (
      <EmptyState text={'No data found'} noIcon boxProps={{ flexGrow: 1, height: undefined }} />
    )
  }

  return (
    <div className={styles.wrapTable}>
      <Table
        ariaLabel={'ClickToTextStatisticsTableClicks'}
        columns={columns}
        rows={statisticsClicksItems}
        rowsCount={total}
        isLoading={isStatisticsClicksLoading}
        onChangePagination={onPaginationTableChange}
        initPage={page}
        limit={limit}
        startPaginationSize={10}
        sxTable={{ marginRight: 2, width: 'calc(100% - 16px)' }}
        store={statisticsClicksTableStore}
        virtualization
      />
    </div>
  )
})
